import React from "react";
import { FaStar } from "react-icons/fa";

interface StarRatingProps {
  rating: number;
  onRatingChange: (rating: number) => void;
  label: string;
  disabled?: boolean;
  size?: "sm" | "md" | "lg";
}

const StarRating: React.FC<StarRatingProps> = ({
  rating,
  onRatingChange,
  label,
  disabled = false,
  size = "md"
}) => {
  const [hoverRating, setHoverRating] = React.useState(0);

  const starSizes = {
    sm: "h-4 w-4",
    md: "h-6 w-6",
    lg: "h-10 w-10"
  };

  return (
    <div className="flex flex-col gap-2">
      {label && <label className="text-sm font-medium text-gray-700">{label}</label>}
      <div className="flex items-center gap-1">
        {[1, 2, 3, 4, 5].map((star) => (
          <button
            key={star}
            type="button"
            disabled={disabled}
            className={`transition-all duration-150 ${disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer hover:scale-110"
              }`}
            onMouseEnter={() => !disabled && setHoverRating(star)}
            onMouseLeave={() => !disabled && setHoverRating(0)}
            onClick={() => !disabled && onRatingChange(star)}
          >
            <FaStar
              className={`${starSizes[size]} ${star <= (hoverRating || rating)
                ? "text-yellow-400"
                : "text-gray-300"
                }`}
            />
          </button>
        ))}
        <span className="ml-2 text-sm text-gray-600">
          {rating > 0 ? `${rating}/5` : "Not rated"}
        </span>
      </div>
    </div>
  );
};

export default StarRating;

